export const filterStockDataByText = (stockData, textSearch) => {
    return stockData.filter(element => {
        if (textSearch.trim() === "") {
            return true
        }
        
        const text = textSearch.trim().toLowerCase().split(" ")
        const adaptData = d => d != null ? String(d).toLowerCase() : ""
        let rowData = adaptData(element.description) + adaptData(element.model) + adaptData(element.brand)
            + adaptData(element.quality) + adaptData(element.color)

        return text.every(t => {
            if (text.length > 1 || t.length > 2) {
                const rowDataWithNumber = rowData + adaptData(element.number)
                return rowDataWithNumber.includes(t)
            }

            return rowData.includes(t)
        })
    })
}